import React, { useContext, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { api_url } from "../helpers";
import { toast } from "react-toastify";
import { userContext } from "../context/UserContext";

const Register = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [mobile, setMobile] = useState("");
  const [username, setUsername] = useState("");
  const { setUser, setLoad } = useContext(userContext);
  const navigate = useNavigate();

  async function handleSubmit(e) {
    e.preventDefault();

    setLoad(true);

    try {
      const response = await fetch(
        api_url +
          `method/erp_sn.api.authentication.signup?email=${email}&full_name=${username}&mobile_no=${mobile}&password=${password}&role_profile=SupplyNest Customer&user_type=System User&user_name=${email}`,
        {
          method: "POST",
        }
      );

      if (response.ok === true) {
        const data = await response.json();

        if (data?.message) {
          toast.success("User Logged In Successfully");

          setUser({
            name: username,
            api_key: data?.message?.api_key,
            api_secret: data?.message?.api_secret,
            customer_id: data?.message?.customer_id,
            email: email,
          });

          setTimeout(() => {
            window.location.pathname = '/'
          }, 300);
        }

        // console.log("data", data);
      }
    } catch (error) {
      console.log(error);
    }

    setTimeout(() => {
      setLoad(false);
    }, 300);
  }

  return (
    <section className="account py-80">
      <div className="container container-lg">
        <form onSubmit={(e) => handleSubmit(e)}>
          <div className="row gy-4 justify-content-center">
            {/* Login Card End */}
            {/* Register Card Start */}
            <div className="col-xl-6">
              <div className="border border-gray-100 hover-border-main-600 transition-1 rounded-16 px-24 py-40">
                <h6 className="text-xl mb-32">Register</h6>
                <div className="mb-24">
                  <label
                    htmlFor="usernameTwo"
                    className="text-neutral-900 text-lg mb-8 fw-medium"
                  >
                    Username <span className="text-danger">*</span>{" "}
                  </label>
                  <input
                    type="text"
                    className="common-input"
                    id="usernameTwo"
                    placeholder="Write a username"
                    required
                    value={username}
                    onChange={(e) => setUsername(e.target.value)}
                  />
                </div>
                <div className="mb-24">
                  <label
                    htmlFor="mobile"
                    className="text-neutral-900 text-lg mb-8 fw-medium"
                  >
                    Mobile Number <span className="text-danger">*</span>{" "}
                  </label>
                  <input
                    type="text"
                    className="common-input"
                    id="mobile"
                    placeholder="Enter your mobile number"
                    value={mobile}
                    required
                    onChange={(e) => setMobile(e.target.value)}
                  />
                </div>
                <div className="mb-24">
                  <label
                    htmlFor="emailTwo"
                    className="text-neutral-900 text-lg mb-8 fw-medium"
                  >
                    Email address
                    <span className="text-danger">*</span>{" "}
                  </label>
                  <input
                    type="email"
                    className="common-input"
                    id="emailTwo"
                    placeholder="Enter Email Address"
                    required
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                  />
                </div>
                <div className="mb-24">
                  <label
                    htmlFor="enter-password"
                    className="text-neutral-900 text-lg mb-8 fw-medium"
                  >
                    Password
                    <span className="text-danger">*</span>
                  </label>
                  <div className="position-relative">
                    <input
                      type="password"
                      className="common-input"
                      id="enter-password"
                      placeholder="Enter Password"
                      defaultValue="password"
                      required
                      value={password}
                      onChange={(e) => setPassword(e.target.value)}
                    />
                    <span
                      className="toggle-password position-absolute top-50 inset-inline-end-0 me-16 translate-middle-y cursor-pointer ph ph-eye-slash"
                      id="#enter-password"
                    />
                  </div>
                </div>
                <div className="my-48">
                  <p className="text-gray-500">
                    Your personal data will be used to process your order,
                    support your experience throughout this website, and for
                    other purposes described in our
                    <Link
                      to="#"
                      className="text-main-600 text-decoration-underline"
                    >
                      {" "}
                      privacy policy
                    </Link>
                    .
                  </p>
                </div>
                <div className="d-flex justify-content-between">
                  <div className="mt-48">
                    <button type="submit" className="btn btn-main py-18 px-40">
                      Register
                    </button>
                  </div>
                  <div className="mt-48 pe-30 d-flex align-items-center">
                    <Link
                      to="/login"
                      className="text-danger-600 text-md fw-semibold hover-text-decoration-underline"
                    >
                      Have an Acoount?
                    </Link>
                  </div>
                </div>
              </div>
            </div>
            {/* Register Card End */}
          </div>
        </form>
      </div>
    </section>
  );
};

export default Register;
